export const UserGroups = {
  FARMER: 'farmer',
  PROJECT_MANAGER: 'project-manager',
  CLIENT_ADMIN: 'client-admin',
  AGRI_PM: 'agricarbon-pm',
  AGRI_QA: 'agricarbon-qa',
  AGRI_ADMIN: 'agricarbon-admin',
} as const;

export const UserGroupNames = {
  FARMER: 'Farmer',
  PROJECT_MANAGER: 'Project Manager',
  CLIENT_ADMIN: 'Client Admin',
  AGRI_PM: 'Agricarbon PM',
  AGRI_QA: 'Agricarbon QA',
  AGRI_ADMIN: 'Agricarbon Admin',
} as const;

export type UserGroup = (typeof UserGroups)[keyof typeof UserGroups];

export const NO_PERMISSIONS_MESSAGE = 'Page not found.';

export const UserPermissions = {
  MARK_AS_COMPLETE_BUTTON: 'PERMISSION_MARK_AS_COMPLETE_BUTTON',
  DOWNLOAD_CSV_BUTTON: 'PERMISSION_DOWNLOAD_CSV_BUTTON',
  PROJECT_DETAIL: 'PERMISSION_PROJECT_DETAIL',
  PROJECT_DETAIL_COMPLETE: 'PERMISSION_PROJECT_DETAIL_COMPLETE',
  FARM_DETAIL: 'PERMISSION_FARM_DETAIL',
  FARM_DETAIL_COMPLETE: 'PERMISSION_FARM_DETAIL_COMPLETE',
  FARM_LIST: 'PERMISSION_FARM_LIST',
  USER_LIST: 'PERMISSION_USER_LIST',
  ADD_USER: 'PERMISSION_ADD_USER',
  EDIT_USER: 'PERMISSION_EDIT_USER',
  DEACTIVATE_USER: 'PERMISSION_DEACTIVATE_USER',
  PROFILE: 'PERMISSION_PROFILE',
  CUSTOMER_LIST: 'PERMISSION_CUSTOMER_LIST',
  EDIT_CUSTOMER: 'PERMISSION_EDIT_CUSTOMER',
  EDIT_PROJECT: 'PERMISSION_EDIT_PROJECT',
  PROJECT_LIST: 'PERMISSION_PROJECT_LIST',
  PDF_REPORT_REGENERATION: 'PERMISSION_PDF_REPORT_REGENERATION',
} as const;
export type UserPermission = (typeof UserPermissions)[keyof typeof UserPermissions];

export const userGroupPermissionRank = [
  UserGroups.AGRI_ADMIN,
  UserGroups.AGRI_QA,
  UserGroups.AGRI_PM,
  UserGroups.CLIENT_ADMIN,
  UserGroups.PROJECT_MANAGER,
  UserGroups.FARMER,
] as const;

export const DEFAULT_PERMISSIONS: Record<UserGroup, readonly UserPermission[]> = {
  [UserGroups.AGRI_ADMIN]: [
    UserPermissions.CUSTOMER_LIST,
    UserPermissions.EDIT_CUSTOMER,
    UserPermissions.EDIT_PROJECT,
    UserPermissions.PROJECT_DETAIL,
    UserPermissions.PROJECT_DETAIL_COMPLETE,
    UserPermissions.FARM_DETAIL,
    UserPermissions.FARM_DETAIL_COMPLETE,
    UserPermissions.FARM_LIST,
    UserPermissions.MARK_AS_COMPLETE_BUTTON,
    UserPermissions.DOWNLOAD_CSV_BUTTON,
    UserPermissions.PROFILE,
    UserPermissions.PROJECT_LIST,
    UserPermissions.USER_LIST,
    UserPermissions.ADD_USER,
    UserPermissions.EDIT_USER,
    UserPermissions.DEACTIVATE_USER,
    UserPermissions.PDF_REPORT_REGENERATION,
  ],
  [UserGroups.AGRI_QA]: [
    UserPermissions.CUSTOMER_LIST,
    UserPermissions.PROJECT_DETAIL,
    UserPermissions.PROJECT_DETAIL_COMPLETE,
    UserPermissions.FARM_DETAIL,
    UserPermissions.FARM_DETAIL_COMPLETE,
    UserPermissions.FARM_LIST,
    UserPermissions.MARK_AS_COMPLETE_BUTTON,
    UserPermissions.DOWNLOAD_CSV_BUTTON,
    UserPermissions.PROFILE,
    UserPermissions.PROJECT_LIST,
    UserPermissions.PDF_REPORT_REGENERATION,
  ],
  [UserGroups.AGRI_PM]: [
    UserPermissions.PROJECT_DETAIL_COMPLETE,
    UserPermissions.EDIT_PROJECT,
    UserPermissions.FARM_DETAIL,
    UserPermissions.FARM_DETAIL_COMPLETE,
    UserPermissions.FARM_LIST,
    UserPermissions.PROFILE,
    UserPermissions.PROJECT_LIST,
    UserPermissions.DOWNLOAD_CSV_BUTTON,
    UserPermissions.PDF_REPORT_REGENERATION,
  ],
  [UserGroups.CLIENT_ADMIN]: [
    UserPermissions.PROJECT_DETAIL_COMPLETE,
    UserPermissions.FARM_DETAIL_COMPLETE,
    UserPermissions.FARM_LIST,
    UserPermissions.PROFILE,
    UserPermissions.PROJECT_LIST,
    UserPermissions.DOWNLOAD_CSV_BUTTON,
    UserPermissions.PDF_REPORT_REGENERATION,
  ],
  [UserGroups.PROJECT_MANAGER]: [
    UserPermissions.FARM_DETAIL_COMPLETE,
    UserPermissions.FARM_LIST,
    UserPermissions.PROFILE,
    UserPermissions.PROJECT_LIST,
    UserPermissions.DOWNLOAD_CSV_BUTTON,
    UserPermissions.PROJECT_DETAIL_COMPLETE,
    UserPermissions.PDF_REPORT_REGENERATION,
  ],
  [UserGroups.FARMER]: [
    UserPermissions.FARM_DETAIL_COMPLETE,
    UserPermissions.FARM_LIST,
    UserPermissions.PROFILE,
    UserPermissions.DOWNLOAD_CSV_BUTTON,
  ],
} as const;
